import React, { Component, Children } from 'react';
import Container from '../../components/Container';
import { Grid, Box,List, ListItem,ListItemIcon, Radio, Divider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import CustomTypo from '../../components/CustomTypo';
import { DeleteWhiteIcon, VisaIcon, CheckIcon } from '../../components/icons';
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import ButtonCustom from '../../components/ButtonCustom';

const drawerWidth = 520;
const styles = theme => ({
    method_container:{
        padding: theme.spacing(4,0,0,0)
    },
    method_pre:{
        padding:theme.spacing(0,2,0,0)
    },
    method: {
        backgroundColor:theme.palette.background.secondary,
        borderRadius: theme.spacing(2),
        padding: theme.spacing(4,4,4,4),
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]:{
            padding: theme.spacing(2),
        }
    },
    button_add:{
        marginTop: theme.spacing(10)
    },
    button_location:{
        marginTop: theme.spacing(4)
    },
    bg_icon:{
        width: theme.spacing(6),
        height: theme.spacing(6),
        borderRadius: theme.spacing(6),
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        backgroundColor: theme.palette.icon.trash,
        cursor: "pointer",
        touchAction: "manipulation",
    }
});
function AddressesView(props) {
    const {classes, t, addresses, onAddAddresses, onRemoveAddress,showLoading, onShowDetail, onSelectCurrentLocation } = props
    return (
        <div>
            <DrawerCustom 
                open={props.open} 
                onClose={()=>props.handleDrawerOtherToggle('address_book')}
                title = {t('my_address')}
                enableBack
                children={        
                        <Grid item>
                            {showLoading?<CustomizedCircularProgress/>:null}
                            {addresses.length>0?addresses.map((item,index)=><AddressItem key ={index} classes={classes} item={item} onRemoveAddress={onRemoveAddress} onShowDetail={onShowDetail}/>):null}
                            <ButtonCustom fullWidth color='primary' className={classes.button_add} onClick={onAddAddresses}>{t('new_address_title')}</ButtonCustom>
                            {props.openFromOrder&&<ButtonCustom fullWidth color='onPrimary' className={classes.button_location} onClick={onSelectCurrentLocation}>{t('my_current_location')}</ButtonCustom>}
                        </Grid>
                    }/>
    </div>
    );
}

function AddressItem(props){
    const {classes, onRemoveAddress} = props
    var item = props.item;
    console.log('AddressItem===',item)
    var address = ""
    if (item.address_line_1) {
        address = address + item.address_line_1;
    }
    if (item.address_line_2) {
        address = address + ", " + item.address_line_2;
    }
    if (item.town_city) {
        address = address + ", " + item.town_city;
    }
    return(
        <div>
        <Grid xs = {12} item container className={classes.method_container}>
            <Grid xs ={11} item className={classes.method_pre}>
                <Grid item container className={classes.method} onClick={() => props.onShowDetail(item)} alignItems='center'>
                    <Grid xs = {4} sm={3} item container alignItems='center'>
                        {/* <CustomTypo variant='body2' color='success'>{item.address_type}</CustomTypo> */}
                        <ButtonCustom size="xs" color={"success"}>{item.address_type}</ButtonCustom>
                    </Grid>
                    <Grid xs = {7} sm={8} item container alignItems='center'>
                        <Grid item xs={12}>
                            <CustomTypo variant='subtitle2'>{item.address_name}</CustomTypo>
                        </Grid>
                        <Grid item xs={12}>
                            <CustomTypo variant='body2' color='primary'>{address}</CustomTypo>
                        </Grid>
                    </Grid>
                    {item.is_primary && <Grid xs={1}  item container justify='flex-end' >
                        <CheckIcon/>
                    </Grid>}
                </Grid>
            </Grid>
            <Grid xs={1} item container justify='flex-end' alignItems='center'>
                    <div className={classes.bg_icon} onClick={() => onRemoveAddress(item)}>
                        <DeleteWhiteIcon />
                    </div>
            </Grid>
        </Grid>
        </div>
    )
}
export default withStyles(styles)(withTranslation()(AddressesView));